<template>
  <span
    class="roomie-check"
    :class="{
      'roomie-check--active': active,
      'roomie-check--disabled': disabled
    }" />
</template>

<script>
export default {
  name: 'RoomieCheck',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style
  src='./_index.scss'
  lang='scss'/>
